/** Clears any Emergent Google session cookie on logout. Safe when none exists. */
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const clearGoogleSession = () =>
  axios.post(`${API}/auth/google/logout`, {}, { withCredentials: true }).catch(() => {});
